import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dc8e801"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cards-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleCardByHour = _resolveComponent("ScheduleCardByHour")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEvents(), (event) => {
      return (_openBlock(), _createElementBlock("div", {
        key: event.id
      }, [
        _createVNode(_component_ScheduleCardByHour, {
          id: event.id,
          place: event.place,
          title: event.title,
          image: event.image,
          hour: event.hour,
          link: event.link,
          event: event
        }, null, 8, ["id", "place", "title", "image", "hour", "link", "event"])
      ]))
    }), 128))
  ]))
}